import { useEffect, useState } from "react";
import { Wifi, WifiOff, RefreshCw, AlertTriangle } from "lucide-react";
import { subscribe, sync, refreshBundle } from "../lib/offline";
import { useLang } from "../lib/i18n";

export const useSyncState = () => {
  const [s, setS] = useState({ online: navigator.onLine, pending: 0, conflicts: [], syncing: false });
  useEffect(() => subscribe(setS), []);
  return s;
};

// Keeps the offline bundle fresh and flushes the queue whenever the connection returns.
export const useSyncDriver = (enabled) => {
  useEffect(() => {
    if (!enabled) return;
    refreshBundle(); sync();
    const on = () => { sync(); };
    const off = () => sync();
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    const iv = setInterval(() => navigator.onLine && sync(), 30000);
    const bv = setInterval(() => navigator.onLine && refreshBundle(), 10 * 60000);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); clearInterval(iv); clearInterval(bv); };
  }, [enabled]);
};

export const SyncBadge = () => {
  const { t } = useLang();
  const s = useSyncState();
  const conflicts = s.conflicts.length;
  const tone = !s.online ? "bg-amber-400 text-slate-900" : conflicts ? "bg-red-500 text-white" : s.pending ? "bg-sky-400 text-slate-900" : "bg-emerald-600 text-white";
  return (
    <button type="button" onClick={() => sync()} data-testid="sync-badge" title={`${s.online ? t("online") : t("offline")} · ${t("sync_now")}`} aria-label={`${s.online ? t("online") : t("offline")} · ${t("sync_now")}`}
      className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-bold whitespace-nowrap ${tone}`}>
      {!s.online ? <WifiOff size={16} /> : conflicts ? <AlertTriangle size={16} /> : s.syncing ? <RefreshCw size={16} className="animate-spin" /> : <Wifi size={16} />}
      <span className={s.online ? "hidden sm:inline" : "inline"}>{s.online ? t("online") : t("offline")}</span>
      {(s.pending > 0 || conflicts > 0) && <span data-testid="sync-pending-count" className="font-mono">{s.pending + conflicts}</span>}
    </button>
  );
};
